module.exports = __webpack_public_path__ + "img/github.45ba1d06.svg";